import {
    FETCH_MEDICLAIM_INVOICELIST_REQUEST,
    FETCH_MEDICLAIM_INVOICELIST_SUCCESS,
    FETCH_MEDICLAIM_INVOICELIST_FAILURE,
  } from "./FetchMediclaimListingTypes";
  import api from "../../utils/Api";
  import axios from 'axios';
  
  export const fetchMediclaimInvoiceListRequest = () => {
    return {
      type: FETCH_MEDICLAIM_INVOICELIST_REQUEST,
    };
  };
  
  export const fetchMediclaimInvoiceListSuccess = (mediclaimInvoiceList) => {
    return {
      type: FETCH_MEDICLAIM_INVOICELIST_SUCCESS,
      payload: mediclaimInvoiceList,
    };
  };
  
  export const fetchMediclaimInvoiceListFailure = (error) => {
    return {
      type: FETCH_MEDICLAIM_INVOICELIST_FAILURE,
      payload: error,
    };
  };
  
  const CancelToken = axios.CancelToken;
  let cancelRequest;
  export const fetchMediclaimInvoiceList = (searchKey, sortBy, page, payload) => {
    //cancel previous request if multiple hits done.
    cancelRequest && cancelRequest();
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    let url = "payment/claimtransaction/fetch?search_key=" +
    searchKey +
    "&sort_by=" +
    sortBy +
    "&page=" +
    page;
  
    if(payload && payload.dateFrom && payload.dateFrom !== "Not Available"){
      url += "&service_start_date=gte:"+ payload.dateFrom;
    }
    if(payload && payload.dateTo && payload.dateTo !== "Not Available"){
        url += "&service_start_date=lte:"+ payload.dateTo;
    }
    if(payload && payload.status){
        url += "&status="+ payload.status;
    }
  
    return async (dispatch) => {
      dispatch(fetchMediclaimInvoiceListRequest());
      try {
        const response = await api.get(
         url,
          {
            headers: headers,
            cancelToken: new CancelToken(function executor(c) {
              cancelRequest = c;
          })
          }
        );
        const mediclaimInvoiceList = response.data.data;
        //console.log("*************** invoiceList", invoiceList);
        dispatch(fetchMediclaimInvoiceListSuccess(mediclaimInvoiceList));
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('Error: ', error.message); // => prints: Api is being canceled
        } 
        console.log("Redux error - ", error.response);
        const errorMsg = error.message;
        dispatch(fetchMediclaimInvoiceListFailure(errorMsg));
      }
    };
  };
  